
import type { SocialStream } from 'src/types/domain/SocialStream'
import type { SocialStreamDTO } from 'src/types/infra/realtime/SocialStreamDTO'

export const fromSocialStreamDTO = (socialStreamDTO: SocialStreamDTO): SocialStream => ({
  id: socialStreamDTO.id,
  streamId: socialStreamDTO.stream_id,
  title: socialStreamDTO.title,
  live: socialStreamDTO.live,
  imageUrl: socialStreamDTO.image_url,
  createdAt: socialStreamDTO.created_at
})